import style from './wallex-title-2.module.scss'
import { InView } from 'react-intersection-observer';
import animations from '@styles/animations.module.scss'

const WallexTitleTwo = (props: any) => {
    let { state, isTitle = false } = props;
    return (
        <InView triggerOnce={true}>
            {({ inView, ref, entry }) => {
                if (inView) {
                    entry?.target.classList.add(animations.active);
                }
                return (
                    <>
                        <div ref={ref} className={`${style.wallex__text} ${isTitle ? style.wallex__text_title : null} ${animations.scroll__animation}`}>
                            {state}
                        </div>
                    </>
                )
            }}
        </InView>
    )


}

export default WallexTitleTwo;
